// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    display: block;
    padding: 20px;
    background-color: #f4f4f4; 
  }
  
  .container {
      font-family: Arial, sans-serif;
      line-height: 1.6;
      max-width: 800px;
      margin: auto;
      background-color: #fff;
      padding: 30px;
      border-radius: 8px;
      box-shadow: 0 0 10px rgba(0,0,0,0.1);
      color: #333;
  }
  
  h1 {
      color: #000000;
      text-align: center;
      margin-bottom: 20px;
  }
  
  h2 {
      color: #000000;
      border-bottom: 2px solid #ebebeb;
      padding-bottom: 10px;
      margin-top: 30px;
  }
  
  h3 { /* If you have h3 tags */
      color: #000000;
      margin-top: 20px;
  }
  
  p {
      margin-bottom: 15px;
  }
  
  ul {
      margin-bottom: 15px;
      padding-left: 20px;
  }
  
  li {
      margin-bottom: 8px;
  }
  
  a {
      color: #7f5c85;
      text-decoration: none;
  }
  
  a:hover {
      text-decoration: underline;
  }
  
  strong {
      color: #000000;
  }
  
  .effective-date {
      text-align: center;
      font-style: italic;
      color: #7f8c8d;
      margin-bottom: 30px;
  }

  code {
    background-color: #f0f0f0;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: monospace;
  }

  .spinner{
    display: none !important;
  }`, "",{"version":3,"sources":["webpack://./angular/src/app/privacy-statement/privacy-statement.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,yBAAyB;EAC3B;;EAEA;MACI,8BAA8B;MAC9B,gBAAgB;MAChB,gBAAgB;MAChB,YAAY;MACZ,sBAAsB;MACtB,aAAa;MACb,kBAAkB;MAClB,oCAAoC;MACpC,WAAW;EACf;;EAEA;MACI,cAAc;MACd,kBAAkB;MAClB,mBAAmB;EACvB;;EAEA;MACI,cAAc;MACd,gCAAgC;MAChC,oBAAoB;MACpB,gBAAgB;EACpB;;EAEA,KAAK,wBAAwB;MACzB,cAAc;MACd,gBAAgB;EACpB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,mBAAmB;MACnB,kBAAkB;EACtB;;EAEA;MACI,kBAAkB;EACtB;;EAEA;MACI,cAAc;MACd,qBAAqB;EACzB;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,cAAc;EAClB;;EAEA;MACI,kBAAkB;MAClB,kBAAkB;MAClB,cAAc;MACd,mBAAmB;EACvB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B","sourcesContent":[":host {\n    display: block;\n    padding: 20px;\n    background-color: #f4f4f4; \n  }\n  \n  .container {\n      font-family: Arial, sans-serif;\n      line-height: 1.6;\n      max-width: 800px;\n      margin: auto;\n      background-color: #fff;\n      padding: 30px;\n      border-radius: 8px;\n      box-shadow: 0 0 10px rgba(0,0,0,0.1);\n      color: #333;\n  }\n  \n  h1 {\n      color: #000000;\n      text-align: center;\n      margin-bottom: 20px;\n  }\n  \n  h2 {\n      color: #000000;\n      border-bottom: 2px solid #ebebeb;\n      padding-bottom: 10px;\n      margin-top: 30px;\n  }\n  \n  h3 { /* If you have h3 tags */\n      color: #000000;\n      margin-top: 20px;\n  }\n  \n  p {\n      margin-bottom: 15px;\n  }\n  \n  ul {\n      margin-bottom: 15px;\n      padding-left: 20px;\n  }\n  \n  li {\n      margin-bottom: 8px;\n  }\n  \n  a {\n      color: #7f5c85;\n      text-decoration: none;\n  }\n  \n  a:hover {\n      text-decoration: underline;\n  }\n  \n  strong {\n      color: #000000;\n  }\n  \n  .effective-date {\n      text-align: center;\n      font-style: italic;\n      color: #7f8c8d;\n      margin-bottom: 30px;\n  }\n\n  code {\n    background-color: #f0f0f0;\n    padding: 2px 4px;\n    border-radius: 3px;\n    font-family: monospace;\n  }\n\n  .spinner{\n    display: none !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
